/*
 * NutriKit mega menu: hover open + persistent active state.
 *
 * Active state: when user hovers an objectif in col 1, the grid gets
 * data-active="<target>" which drives both the panel visibility AND the
 * visual highlight of the objectif. This persists when the cursor moves
 * to col 2 or col 3, so the user always knows which objectif is active.
 */
(function () {
  'use strict';

  const DESKTOP_MIN = 990;
  const CLOSE_DELAY_MS = 180;
  const DEFAULT_ACTIVE = 'prise-de-masse';

  function init() {
    const details = document.querySelector('.nutrikit-mega');
    if (!details) return;

    const summary = details.querySelector('summary');
    const grid = details.querySelector('.nutrikit-mega__grid');
    if (!summary || !grid) return;

    // Ensure an initial data-active value
    if (!grid.hasAttribute('data-active')) {
      grid.setAttribute('data-active', DEFAULT_ACTIVE);
    }

    const objectifs = grid.querySelectorAll('.nutrikit-mega__objectif');
    let closeTimer = null;

    function isDesktop() {
      return window.matchMedia('(min-width: ' + DESKTOP_MIN + 'px)').matches;
    }

    function open() {
      if (!isDesktop()) return;
      clearTimeout(closeTimer);
      if (!details.hasAttribute('open')) {
        details.setAttribute('open', '');
        summary.setAttribute('aria-expanded', 'true');
      }
    }

    function close() {
      if (!isDesktop()) return;
      if (details.hasAttribute('open')) {
        details.removeAttribute('open');
        summary.setAttribute('aria-expanded', 'false');
      }
      // reset to default active on close
      grid.setAttribute('data-active', DEFAULT_ACTIVE);
    }

    function scheduleClose() {
      if (!isDesktop()) return;
      clearTimeout(closeTimer);
      closeTimer = setTimeout(close, CLOSE_DELAY_MS);
    }

    // Persistent active state: mouseenter on an objectif updates data-active
    objectifs.forEach(function (obj) {
      obj.addEventListener('mouseenter', function () {
        const target = obj.getAttribute('data-target');
        if (target) grid.setAttribute('data-active', target);
      });
      // Also update on focus for keyboard navigation
      obj.addEventListener('focus', function () {
        const target = obj.getAttribute('data-target');
        if (target) grid.setAttribute('data-active', target);
      });
    });

    // Open on hover of the whole details element
    details.addEventListener('mouseenter', open);
    details.addEventListener('mouseleave', scheduleClose);

    // Click on summary toggles (desktop only - prevent native behavior)
    summary.addEventListener('click', function (e) {
      if (isDesktop()) {
        e.preventDefault();
        if (details.hasAttribute('open')) {
          close();
        } else {
          open();
        }
      }
    });

    // Close on outside click
    document.addEventListener('click', function (e) {
      if (isDesktop() && !details.contains(e.target)) {
        close();
      }
    });

    // Close on Escape
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && details.hasAttribute('open')) {
        close();
      }
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
